import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  returnUrl: string = "/";
  
  constructor(public route: ActivatedRoute,
              private authenticationService: AuthenticationService) {
    
    route.queryParams.subscribe(queryParams => {
      if (queryParams["returnUrl"]) {
        this.returnUrl = queryParams["returnUrl"];
      }
    })
  }

  oauth2Login() {
    this.authenticationService.login(this.returnUrl);
  }
}
